import { useEffect, useRef } from 'react';

import {
  pushBackButtonHandler,
  BackButtonHandler,
} from '../utils/androidBackButton';

/**
 * Se queda con el botón «atrás» de Android mientras `active` sea cierto.
 *
 * Pensado para lo que en el navegador se cierra con Escape: una capa abierta
 * encima de la pantalla (el mapa a pantalla completa, un modal, un visor). En
 * Android el gesto equivalente es «atrás», y sin esto la pulsación se lleva al
 * operario FUERA de la página en vez de cerrar lo que tiene delante.
 *
 * Con `active` a `false` no hay nada registrado, y con la pila vacía tampoco
 * hay listener nativo — ver el porqué en `utils/androidBackButton.ts`. Fuera
 * de la app nativa es un no-op.
 *
 * El manejador se lee de una ref, así que puede cerrar sobre estado fresco sin
 * que cada render lo desregistre y lo vuelva a registrar.
 */
export function useAndroidBackButton(
  active: boolean,
  handler: BackButtonHandler
): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!active) return undefined;
    return pushBackButtonHandler(() => handlerRef.current());
  }, [active]);
}
